<form [formGroup]="utilityForm" *ngIf="utilityForm && utilities" style="margin: 0 20px">
  <div class="row">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-select class="custom-select" (change)="setDirtyForm()" formControlName="utility">
        <mat-option [value]="''">None Selected</mat-option>
        <mat-option *ngFor="let utility of utilities" [value]="utility.shortName">{{utility.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <br>
  <div class="flex items-center justify-end">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="!utilityForm.dirty" style="margin-right: 0.5rem">Save</button>
    <button mat-flat-button color="warn" (click)="cancel()" [disabled]="!utilityForm.dirty">Cancel</button>
  </div>
  <br />
</form>
